import {
  generalTerm,
} from '@/constants/locales/sk.shared.ts';

export default {
  setpoints: {
    header: 'Žiaduce hodnoty',
  },
  properties: {
    header: 'Vlastnosti',
    representativeCouponDiameterLabel: generalTerm.representativeDiameter,
    halfInfiniteRadio: 'Polo-nekonečný',
    shapeOrientedRadio: 'Podľa tvaru',
  },
  carburizing: {
    header: 'Cementovanie',
  },
  nitriding: {
    header: 'Nitridácia',
    preNitridedCondition: 'Stav pred nitridáciou',
    estimatedTemperingConditions: 'Odhadované podmienky zušľachťovania',
  },
  isnitridingHardnessEffective: {
    true: 'Účinná',
    false: 'Jadro +',
  },
  materialSimulationData: {
    header: 'Dáta simulácie materiálu',
  },
  savePartAs: {
    header: 'Uložiť diel ako',
  },
  newPartDisplayName: 'Nový diel',
  cContent: 'Obsah C v % hm.',
  nContent: 'Obsah N v % hm.',
  cnContent: 'Obsah C/N v % hm.',
  depthCore: 'Hĺbka jadra v mm',
  depth: 'Hĺbka v mm',
  preprocessedProfile: 'Predspracovaný profil',
  parametrizedProfile: 'Parametrizovaný profil',
  parametrizedProfileDescription: 'Definujte profil dielu zadaním obsahu povrchu a jadra.',
  surfaceContent: 'Povrchový obsah',
  coreContent: 'Základný obsah',
  setpointsDescription: 'Rozšírte profil zadaním explicitných hodnôt.',
  surfaceHardnessCannotBeAchieved: 'Takú tvrdosť povrchu nie je možné dosiahnuť',
};
